/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from 'react-i18next';
import { EpButton } from '../../../components/EpButton';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { userService } from '../../../services/userService';
import { useHospitalStore } from '../../../stores';
import { useTranslationStore } from '../../../stores/useTranslationStore';
import styles from '../EpStarter.module.scss';
import { StarterModal } from '../EpStarterModal';

/** @TODO - remover a linha abaixo quando resolver o problema de import no layout.tsx */
import '../../../internationalization/i18n';
import { usePathname } from 'next/navigation';
import { EpimedLogoSVGCode } from '../../../components/EpHeaderNavigation/EpimedLogo';

export const DefaultHeader = ({ cultures }: { cultures: any }) => {
  const { i18n } = useTranslation();
  const { translations } = useTranslationStore((state) => state);
  const { hospitalInfo } = useHospitalStore((state) => state);
  const pathname = usePathname();
  const isPublicPath = pathname.includes('Public');
  const { data: hospitalLogo = '' } = userService.getHospitalLogoNotLogged(
    hospitalInfo ? hospitalInfo?.HospitalId : '',
    !!hospitalInfo?.HospitalId && isPublicPath,
  );
  const hospitalLogoUrl = hospitalLogo?.filePath ? hospitalLogo?.filePath : '';

  return (
    <header className={styles['header']}>
      <EpimedLogoSVGCode />

      <div className={styles['header__options']}>
        <EpButton
          buttonId="ep-modal__language--button"
          customClasses="header__button--language text-white"
          buttonSize="md"
          buttonType="link-light"
          buttonDataBsTarget="#ep-modal__language"
          buttonDataBsToggle="modal"
          buttonLeftIconName="SolidGlobe"
          buttonText={t(translations['global'], 'Language ({0})').replace(
            '{0}',
            i18n.language,
          )}
        />

        {hospitalLogo?.filePath && (
          <img
            src={hospitalLogoUrl}
            style={{ height: 'auto', maxWidth: '200px' }}
            alt="Hospital Logo"
          />
        )}

        <StarterModal
          cultures={cultures}
          handleLanguage={(value: string) => i18n.changeLanguage(value)}
          translations={translations['global']}
        />
      </div>
    </header>
  );
};
